import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const SpectatorIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.98714 6.37663C8.15796 6.37663 9.1071 5.42749 9.1071 4.25667C9.1071 3.08586 8.15796 2.13672 6.98714 2.13672C5.81632 2.13672 4.86719 3.08586 4.86719 4.25667C4.86719 5.42749 5.81632 6.37663 6.98714 6.37663Z"
        fill="currentColor"
      />
      <path
        d="M13.8898 4.07034L11.9408 2.0857C10.6438 0.767615 8.87706 0.0176641 7.02797 0.000308056C5.17888 -0.017048 3.39838 0.699607 2.07691 1.99312L0.104141 3.94215C0.0374563 4.00891 0 4.09942 0 4.19379C0 4.28815 0.0374563 4.37866 0.104141 4.44543L2.05317 6.43007C3.34981 7.74873 5.11666 8.49908 6.96594 8.51644C8.81523 8.5338 10.5958 7.81674 11.917 6.52265L13.9017 4.57362C13.9668 4.50529 14.0021 4.4139 13.9999 4.31952C13.9977 4.22515 13.9581 4.13552 13.8898 4.07034ZM6.96254 7.09003C6.40201 7.08672 5.85506 6.91714 5.39097 6.60278C4.92687 6.28842 4.5665 5.84341 4.35548 5.32411C4.14446 4.8048 4.09229 4.23455 4.20557 3.68558C4.31885 3.1366 4.59249 2.63358 4.99184 2.24023C5.39119 1.84687 5.89828 1.58086 6.4489 1.47589C6.99953 1.37092 7.56892 1.4317 8.08498 1.65054C8.60104 1.86939 9.04055 2.23645 9.34786 2.70524C9.65517 3.17403 9.81646 3.72348 9.8113 4.284C9.80378 5.03329 9.49987 5.74911 8.96603 6.27494C8.43219 6.80078 7.71186 7.09383 6.96254 7.09003Z"
        fill="currentColor"
      />
    </svg>
  )
})

SpectatorIcon.displayName = 'SpectatorIcon'
